import { render, staticRenderFns } from "./CustomToast.vue?vue&type=template&id=13604825&scoped=true"
import script from "./CustomToast.vue?vue&type=script&lang=js"
export * from "./CustomToast.vue?vue&type=script&lang=js"
import style0 from "./CustomToast.vue?vue&type=style&index=0&id=13604825&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13604825",
  null
  
)

export default component.exports